export default __webpack_public_path__ + "static/media/check.8b157218.svg";